import { ExternalMedia } from './external-media';
import { HandoverHandoverSettings } from './handover-handover-settings';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class EditHandoverCommand {
  HandoverId: string;
  Scaffolds: string[];
  Media: ExternalMedia[];
  NextInspectionDate: string;
  HandoverHandoverSettings: HandoverHandoverSettings[];
  HandoverComments: string;
  When: string;
  HirePeriod: number;
  CommandVersion: string;
  SourceApp: string;
  SourceAppVersion: string;
}


